import React, { Fragment } from 'react';
import { HourglassIcon } from 'lucide-react';
import {
  Message,
  MessageContent,
} from '@cotera/client/v0/components/ai-elements/message';

interface WaitingForApprovalPlaceholderProps {
  count?: number;
  className?: string;
}

/**
 * A placeholder message shown when one or more tools are waiting for user approval.
 * This appears in the message chain to indicate that the conversation is paused
 * waiting for user interaction.
 */
export const WaitingForApprovalPlaceholder: React.FC<
  WaitingForApprovalPlaceholderProps
> = ({ count = 1 }) => {
  return (
    <Fragment>
      <Message from="assistant">
        <MessageContent>
          <div className="flex items-center gap-2">
            <HourglassIcon className="h-4 w-4 animate-pulse text-amber-500" />
            <span>
              {count === 1
                ? 'Waiting for approval…'
                : `Waiting for approval (${count} tools)…`}
            </span>
          </div>
        </MessageContent>
      </Message>
    </Fragment>
  );
};
